<template>
  <div class="container">
    <el-card class="mb5">
      <div class="searchBox">
        <el-form
          ref="searchForm" v-model="queryForm" :inline="false"
          label-position="top"
        >
          <el-row :gutter="20">
            <el-col :span="4">
              <!-- 流向名称 -->
              <el-form-item :label="$t('routes.flowName')">
                <el-select
                  v-model="queryForm.params.flowDirectName"
                  :placeholder="$t('GlobalSetObj.all')"
                  clearable
                  filterable
                  size="small"
                  style="width: 100%"
                  @focus="getFlowDirectNameList()"
                >
                  <el-option
                    v-for="(item, index) in flowDirectNameList"
                    :key="index"
                    :label="item"
                    :value="item"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="5">
              <!--发车转运中心-->
              <el-form-item :label="$t('routes.departureTransferCenter')">
                <el-select
                  v-model="queryForm.params.departTransferCenterId"
                  :placeholder="$t('GlobalSetObj.all')"
                  clearable
                  filterable
                  size="small"
                  style="width: 100%"
                >
                  <el-option
                    v-for="item in transferCenterList"
                    :key="item.siteId"
                    :label="item.siteName"
                    :value="item.siteId"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="5">
              <!--  干支线  -->
              <el-form-item :label="$t('routes.trunkLine')">
                <el-select
                  v-model="queryForm.params.type"
                  :placeholder="$t('GlobalSetObj.all')"
                  clearable
                  size="small"
                  style="width: 100%"
                >
                  <el-option key="1" :label="$t('basicData.trunkLine')" :value="1" />
                  <el-option key="2" :label="$t('basicData.branchLine')" :value="2" />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <!-- 下一站流向 -->
              <el-form-item :label="$t('routes.下一站流向')">
                <el-select
                  v-model="queryForm.params.nextSiteId"
                  :placeholder="$t('GlobalSetObj.all')"
                  clearable
                  filterable
                  size="small"
                  style="width: 100%"
                >
                  <el-option
                    v-for="item in siteList"
                    :key="item.siteId"
                    :label="item.siteName"
                    :value="item.siteId"
                  />
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row style="margin-bottom: 10px">
            <!--搜索-->
            <el-button
              size="small" type="primary" @click="enterGetSearch01"
            >{{ $t('newOrder.search') }}
            </el-button>
            <!--重置-->
            <el-button
              size="small" type="info" @click="resetData"
            >{{ $t('newOrder.reset') }}
            </el-button>
            <el-button
              size="small" type="primary" @click="newCode"
            >{{ $t('routes.新增流向') }}
            </el-button>
            <el-button size="small" @click="toBulkImport">{{ $t('basicData.BulkImport') }}</el-button>
          </el-row>
        </el-form>
      </div>
    </el-card>
    <el-card>
      <el-table
        :data="tableData"
        :header-cell-style="{ background: '#f2f2f2', color: 'black' }"
        border
        style="width: 100%"
        max-height="600"
        class="tableClass"
      >
        <el-table-column
          :label="$t('GlobalSetObj.serial')" align="center" type="index"
          width="80"
        />
        <el-table-column
          v-for="item in tableHeaderList"
          :key="item.id"
          :align="item.center"
          :label="item.label"
          :min-width="item.cloWidth"
          :prop="item.prop"
          :show-overflow-tooltip="false"
        >
          <!--        <template slot-scope="scope">-->
          <!--          <div v-if="item.prop === 'orderNumber'">-->
          <!--            {{ scope.row.orderNumber }}-->
          <!--          </div>-->
          <!--          <div v-else-if="item.prop === 'paymentVoucher'">-->
          <!--            <div v-if="scope.row[item.prop] === 1" style="color: #00A551">-->
          <!--              {{ $t('customerManagements.approved') }}-->
          <!--            </div>-->
          <!--            <div v-else-if="scope.row[item.prop] === 2" style="color: #f00">-->
          <!--              {{ $t('orderCenterCont.ReviewFailed') }}-->
          <!--            </div>-->
          <!--          </div>-->
          <!--          <div v-else>{{ scope.row[item.prop] ? `${scope.row[item.prop]}` : '&#45;&#45;' }}</div>-->
          <!--        </template>-->
          <template slot-scope="scope">
            <!-- 动态渲染三列 -->
            <template v-if="['nextSiteName', 'expectedArriveTime', 'acrossDayName'].includes(item.prop)">
              <div v-for="(stop, index) in scope.row.nextSiteList" :key="index" class="multi-row-cell">
                {{ stop[item.prop] || '--' }}
              </div>
            </template>

            <!-- 合并单元格的列 -->
            <template v-else-if="item.rowspan">
              <div :rowspan="scope.row.nextSiteList ? scope.row.nextSiteList.length : 1" class="rowspan-cell">
                {{ scope.row[item.prop] ? scope.row[item.prop] : '--' }}
              </div>
            </template>

            <!-- 其他普通列 -->
            <template v-else>
              <div>{{ scope.row[item.prop] ? scope.row[item.prop] : '--' }}</div>
            </template>
          </template>
        </el-table-column>
        <el-table-column
          :label="$t('newOrder.operation')" align="center" fixed="right"
          width="100"
        >
          <template slot-scope="scope">
            <div class="flx-around">
              <i class="el-icon-edit textOperator" @click="newCode(scope.row)" />
              <el-popconfirm :title="$t('trailer.AreYouSureDelete')" @confirm="delData(scope.row)">
                <el-button
                  slot="reference" size="mini" type="text"
                ><i
                  class="el-icon-delete" style="font-size: 18px"
                /></el-button>
              </el-popconfirm>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        :current-page.sync="queryForm.pageNumber"
        :page-size.sync="queryForm.pageSize"
        :page-sizes="[10, 50, 100, 200, 400]"
        :total="queryForm.total"
        background
        layout="total, sizes, prev, pager, next, jumper"
        style="margin: 20px 0; text-align: right"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </el-card>
    <!--  生成邀请码  -->
    <newDrawer
      ref="newCodeDialogRef"
      :position-list="positionList"
      :site-list="siteList"
      :transfer-center-list="transferCenterList"
      @invoke-search="enterGetSearch01"
    />
    <bulkImport ref="bulkImportRef" @invoke-search="enterGetSearch" />
    <resultTip ref="resultTipRef" :result-data="resultData" />
  </div>
</template>

<script>
import { headerList } from '@/views/route/trunkLineManagement/tableHeadListData';
import newDrawer from '@/views/route/trunkLineManagement/component/newAdd.vue';
import bulkImport from '@/views/route/trunkLineManagement/component/bulkImport.vue';
import resultTip from '@/views/route/trunkLineManagement/component/resultTip.vue';
import { positionList } from '@/utils/enumData';
import {
  branchLinePageApi,
  delFlowDirectNameApi,
  getFlowDirectName,
  getSiteAndTransfer
} from '@/api/newExpressAPI';

export default {
  name: 'LargeOrderManagement',
  components: {
    newDrawer,
    bulkImport,
    resultTip
  },
  data() {
    return {
      isTormat: false,
      tableHeaderList: headerList,
      tableData: [],
      queryForm: {
        pageSize: 10,
        pageNumber: 1,
        params: {
          flowDirectName: '',
          departTransferCenterId: null,
          type: null,
          nextSiteId: null
        }
      },
      transferCenterList: [],
      siteList: [],
      // 勾选表格数据
      selectionList: [],
      keyChange: '',
      positionList: positionList,
      flowDirectNameList: [],
      resultData: null
    };
  },
  mounted() {
    if (this.$i18n.locale !== 'zh') {
      this.isTormat = true;
    }
    this.getSearch();
    this.getSiteOrTransfer([3]);
    this.getSiteOrTransfer([2, 3]);
    this.getFlowDirectNameList();
  },
  methods: {
    // 点击生成邀请码
    newCode(row) {
      const rowData = row ? JSON.parse(JSON.stringify(row)) : null;
      this.$refs.newCodeDialogRef.openCodeDialog(rowData);
    },
    toBulkImport() {
      this.$refs.bulkImportRef.openDialog();
    },
    enterGetSearch01() {
      this.queryForm.pageNumber = 1;
      this.getSearch();
    },
    // 搜索
    getSearch() {
      const data = {
        pageNumber: this.queryForm.pageNumber,
        pageSize: this.queryForm.pageSize,
        params: {
          flowDirectName: this.queryForm.params.flowDirectName,
          departTransferCenterId: this.queryForm.params.departTransferCenterId,
          type: this.queryForm.params.type,
          nextSiteId: this.queryForm.params.nextSiteId
        }
      };
      branchLinePageApi(data).then((res) => {
        if (res.code === 200) {
          this.queryForm.total = res.data.total;
          this.tableData = res.data.records;
          this.tableData.forEach((item) => {
            // if (item.acrossDay !== null) {
            //   item.acrossDayName = '+' + item.acrossDay;
            // }
            item.nextSiteList.forEach((ite) => {
              if (ite.acrossDay === 0) {
                ite.acrossDayName = this.$t('collectionCenter.sameDay');
              } else if (ite.acrossDay !== null) {
                ite.acrossDayName = '+' + ite.acrossDay;
              }
            });
            console.log(item, 'branchLinePageApi');
          });
        }
      });
    },
    // 分页
    handleSizeChange(val) {
      this.queryForm.pageNumber = 1;
      this.queryForm.pageSize = val;
      this.getSearch();
    },
    handleCurrentChange(val) {
      this.queryForm.pageNumber = val;
      this.getSearch();
    },
    resetData() {
      this.queryForm = {
        pageSize: 10,
        pageNumber: 1,
        params: {
          flowDirectName: '',
          departTransferCenterId: null,
          type: null,
          nextSiteId: null
        }
      };
      this.getSearch();
    },
    // 删除规则
    async delData(row) {
      const res = await delFlowDirectNameApi(row.id);
      if (res.code === 200) {
        this.$message.success(this.$t('GlobalSetObj.DeleteSuccessful'));
        this.getSearch();
      }
    },
    enterGetSearch(arg) {
      console.log(arg, '3213213');
      this.queryForm.pageNumber = 1;
      this.resetData();
      if (arg) {
        this.resultData = arg;
        this.$refs.resultTipRef.openResultDialog(arg);
      }
    },
    // 获取流向名称
    getFlowDirectNameList() {
      getFlowDirectName().then((res) => {
        if (res.code === 200) {
          this.flowDirectNameList = res.data;
        }
      });
    },
    getSiteOrTransfer(arr) {
      getSiteAndTransfer(arr).then((res) => {
        if (res.code === 200) {
          if (arr.length === 1) {
            this.transferCenterList = res.data;
          } else {
            this.siteList = res.data;
          }
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.tableClass ::v-deep .cell {
  padding-left: 0 !important;
  padding-right: 0 !important;
}
.tableClass ::v-deep td.el-table__cell {
  padding: 10px 0 !important;
}
.multi-row-cell {
  padding: 10px 0;
  border-bottom: 1px solid #eee;
}
.multi-row-cell:first-child {
  padding-top: 0 !important;
}
.multi-row-cell:last-child {
  padding-bottom: 0 !important;
  border-bottom: none;
}
.rowspan-cell {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.container {
  padding: 10px;
}

.searchBox >>> .selectClass .el-input__inner {
  font-weight: 700 !important;
}

.textOperator {
  font-size: 20px;
  color: #00A551;
  cursor: pointer;
}
</style>
